import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import CustomSelect from '../../../components/Select/CustomSelect';
import Card from '../../../components/Card/Card';
import getArticlesTheme from '../../../thunks/articles/getArticlesTheme';
import ButtonTypes from '../../../constants/buttonTypes';
import Button from '../../../components/Button/Button';
import { IconPlus } from '../../../assets/icon';
import CreateArticlesThemeModal from './CreateArticlesThemeModal';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';
const buttonClassName = 'px-[8px] py-[8px] font-normal text-[12px]';

const ArticlesTheme = ({ value, onSelect }) => {
  const dispatch = useDispatch();
  const { articlesThemeList, articlesThemeLoading } = useSelector((state) => ({
    articlesThemeList: state?.getArticlesTheme?.list,
    articlesThemeLoading: state?.getArticlesTheme?.loading,
  }), shallowEqual);
  const [newThemeModalVisibility, setNewThemeModalVisibility] = useState(false);

  useEffect(() => {
    if (!articlesThemeList.length && !articlesThemeLoading) {
      dispatch(getArticlesTheme());
    }
  }, []);

  return (
    <Card
      headerTitle="Section"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
      required
    >
      <CustomSelect
        options={articlesThemeList}
        isSearchable={false}
        placeholder={articlesThemeLoading ? 'Loading...' : 'Select section'}
        onChange={onSelect}
        value={value}
        isDisabled={articlesThemeLoading}
        isMulti
      />
      <br />
      <Button
        icon={<IconPlus />}
        text="New theme"
        type={ButtonTypes.LIGHT_PRIMARY}
        onClick={() => setNewThemeModalVisibility(true)}
        tooltipId="newTheme"
        tooltip="Create new theme"
        containerStyle={buttonClassName}
      />
      <CreateArticlesThemeModal
        visible={newThemeModalVisibility}
        toggleVisible={() => setNewThemeModalVisibility(false)}
      />
    </Card>
  );
};

ArticlesTheme.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func,
};

ArticlesTheme.defaultProps = {
  onSelect: () => {},
  value: null
};

export default ArticlesTheme;
